import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Warning } from '../../theme/theme';
import { Button } from "../Button";

const AlertDialog = ({
  show,
  handleYes,
  handleNo,
  yesText,
  noText,
  children,
}) => {
  const [disableYes, setDisableYes] = useState(false);
  const [disableNo, setDisableNo] = useState(false);

  useEffect(() => {
    return () => {
      setDisableYes(false);
      setDisableNo(false);
    };
  }, []);

  const _handleYes = async () => {
    setDisableYes(true);
    await handleYes();
    setDisableYes(false);
  };
  const _handleNo = async () => {
    setDisableNo(true);
    await handleNo();
    setDisableNo(false);
  };
  return (
    <Modal show={show} backdrop="static" centered>
      <Modal.Body>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            size="4x"
            style={{ margin: 32, color: Warning }}
          />
          {children}
        </div>
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: "center" }}>
        <Button
          style={{ margin: "8px", minWidth: "152px" }}
          outlined
          onClick={_handleNo}
          disabled={disableNo}
        >
          {noText || "No"}
        </Button>
        <Button
          style={{ margin: "8px", minWidth: "152px" }}
          contained
          onClick={_handleYes}
          disabled={disableYes}
        >
          {yesText || "Yes"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AlertDialog;
